import { Component } from '@angular/core';
import { version, commitHash } from 'src/environments/buildInfo';
import * as env from 'src/environments/environment';

@Component({
  selector: 'settings-for-about',
  standalone: true,
  imports: [],
  templateUrl: './settings-for-about.component.html',
  styleUrl: './settings-for-about.component.scss',
})
export class SettingsForAboutComponent {
  version = version;
  commitHash = commitHash;
  env = env;
}
